export { default as NTime, timeProps } from './src/Time';
